import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const assurances = ['Payment is one-time · No subscription', 'Instant download of all materials', '30-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="w-full bg-ink text-paper" data-id="element-85" data-mp="15d414aum8ypg">
      <div className="mx-auto max-w-3xl px-4 py-12 text-center sm:px-5 sm:py-16 lg:py-24" data-id="element-86" data-mp="15fgialsjv51g">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust-soft sm:text-xs" data-id="element-87" data-mp="1jbadk20ehvw3">
          Final countdown
        </p>
        <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight sm:mt-4 sm:text-4xl lg:text-5xl" data-id="element-88" data-mp="1t3g6bdyh8hcc">
          Complete bundle, tonight’s price
        </h2>

        <div className="mt-7 flex justify-center sm:mt-8" data-id="element-89" data-mp="223mimwifvb9x">
          <Countdown tone="dark" data-id="element-90" data-mp="2245wo24yxfio" />
        </div>

        <p className="mt-8 text-[10px] font-semibold uppercase tracking-[0.14em] text-paper/60 sm:mt-10 sm:text-xs" data-id="element-91" data-mp="1x4te3tl4qulw">
          6 volumes + 5 free bonuses
        </p>
        <p className="mt-3 flex items-baseline justify-center gap-3" data-id="element-92" data-mp="n7p7lidtzjlw">
          <span className="font-display text-5xl font-semibold tracking-tight sm:text-6xl" data-id="element-93" data-mp="s5gxk6ux0vng">$19</span>
          <span className="font-display text-xl font-medium text-paper/50 line-through sm:text-2xl" data-id="element-94" data-mp="x2z5btx754tv">
            $745
          </span>
        </p>
        <p className="mt-2 text-sm font-semibold text-rust-soft" data-id="element-95" data-mp="164gk98yvb0gz">You save $726 today</p>

        <div className="mt-7 flex justify-center sm:mt-9" data-id="element-96" data-mp="162m9gnhb8oqm">
          <CtaButton size="large" align="center" placement="final_countdown" label="Yes, I want to save time and retain more students!" mobileLabel="Yes, I want the bundle — $19" data-id="element-97" data-mp="1b28mavt882yw" />
        </div>

        <ul className="mt-7 flex flex-col items-center gap-2 text-[13px] text-paper/70 sm:mt-8 sm:flex-row sm:justify-center sm:gap-6 sm:text-sm" data-id="element-98" data-mp="1pszfo8agva44">
          {assurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-99" data-mp="3qufgxynvg0wd">
              <CheckIcon className="h-4 w-4 shrink-0 text-rust-soft" aria-hidden="true" data-id="element-100" data-mp="3qux8wj3i3syh" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}